import { $ } from './jquery';
import mapboxgl from 'mapbox-gl';

// https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css

window.initiateMap = (container, coordinates, centerCoordinates, zoom, outputId) => {
    showLoading();

    mapboxgl.accessToken = 'pk.eyJ1IjoicmFpbHNjYW5uZXIiLCJhIjoiY2tiamhsOWxhMHBqNzJ0cXY2MWRnamk0NyJ9.hMilr40DBRw4e2FlmBHemw';
    let map = new mapboxgl.Map({
        container: container,
        style: 'mapbox://styles/railscanner/ckidur8oa0j9119rywtumuo13',
        center: centerCoordinates,
        zoom: zoom
    });

    let features = [];

    coordinates.forEach(coordinate => {
        features.push({
            'type': 'Feature',
            'properties': coordinate,
            'geometry': {
                'type': 'Point',
                'coordinates': [coordinate.lon, coordinate.lat]
            }
        });
    });
    
    let firstLoadHappened = false;

    async function firstLoad() {
        if (firstLoadHappened) return;

        if (map.isSourceLoaded('places')) {
            firstLoadHappened = true;
            retrieveBusinessList();
        } else {
            setTimeout(() => firstLoad(), 100);
        }
    }

    firstLoad();

    map.on('load', () => {
        map.loadImage(
            '/dist/img/mapbox-marker-icon-20px-red.png',
            (error, image) => {
                if (error) throw error;
                map.addImage('custom-marker', image);

                map.addSource('places', {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': features,
                    },
                    cluster: true,
                    clusterMaxZoom: 14,
                    clusterRadius: 50,
                });

                map.addLayer({
                    id: 'clusters',
                    type: 'circle',
                    source: 'places',
                    filter: ['has', 'point_count'],
                    paint: {
                        // Use step expressions (https://docs.mapbox.com/style-spec/reference/expressions/#step)
                        // with three steps to implement three types of circles:
                        //   * Blue, 20px circles when point count is less than 100
                        //   * Yellow, 30px circles when point count is between 100 and 750
                        //   * Pink, 40px circles when point count is greater than or equal to 750
                        'circle-color': [
                            'step',
                            ['get', 'point_count'],
                            '#51bbd6',
                            100,
                            '#f1f075',
                            200,
                            '#f28cb1'
                        ],
                        'circle-radius': [
                            'step',
                            ['get', 'point_count'],
                            20,
                            100,
                            30,
                            200,
                            40
                        ]
                    }
                });

                map.addLayer({
                    id: 'cluster-count',
                    type: 'symbol',
                    source: 'places',
                    filter: ['has', 'point_count'],
                    layout: {
                        'text-field': ['get', 'point_count_abbreviated'],
                        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                        'text-size': 12
                    }
                });        

                map.addLayer({
                    'id': 'places',
                    'type': 'symbol',
                    'source': 'places',
                    'filter': ['!', ['has', 'point_count']],
                    'layout': {
                        'icon-image': 'custom-marker'
                    }
                });

                const popup = new mapboxgl.Popup({
                    closeButton: true,
                    closeOnClick: true
                });

                map.on('click', 'places', (e) => {
                    window.location.href = e.features[0].properties.link;
                });
                map.on('click', 'cluster-count', (e) => {
                    map.zoomTo(map.getZoom() + 1, {center: e.features[0].geometry.coordinates});
                });

                map.on('mouseenter', 'places', (e) => {
                    map.getCanvas().style.cursor = 'pointer';

                    const coordinates = e.features[0].geometry.coordinates.slice();
                    const description = e.features[0].properties.description;

                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    popup.setLngLat(coordinates).setHTML(description).addTo(map);
                });

                map.on('mouseleave', 'places', () => {
                    map.getCanvas().style.cursor = '';
                    popup.remove();
                });
            }
        );
    });

    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.GeolocateControl());
    map.addControl(new mapboxgl.NavigationControl());

    map.on('moveend', () => {
        showLoading();

        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set('lat', map.getCenter().lat);
        searchParams.set('lon', map.getCenter().lng);
        searchParams.set('zoom', map.getZoom());
        searchParams.delete('page');
        updateUrlState(searchParams);

        retrieveBusinessList();
    });

    $('body').on('click', 'a.map-link', function(e) {
        showLoading();

        e.preventDefault();
        let pageLink = new URLSearchParams(e.currentTarget.href.split('?')[1]);
        let page = pageLink.get('page');

        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set('page', page);
        updateUrlState(searchParams);

        retrieveBusinessList();
    });

    function showLoading() {
        document.getElementById(outputId).innerHTML = '<div class="mt-5 d-flex justify-content-center" role="status"><span class="spinner-border" /></div>';
    }

    function retrieveBusinessList() {
        const features = map.querySourceFeatures('places');
        console.log(features, coordinates);
        // let businessIds = [];

        let renderIds = features.map(feature => feature.properties.id).filter(Boolean);
        let resultIds = coordinates.map(coordinate => coordinate.id);

        
        // features.forEach(feature => {
        //     businessIds.push(feature.properties.id)
        // });

        renderIds = [...new Set(renderIds)];
        resultIds = [...new Set(resultIds)];

        console.log(resultIds, renderIds);

        let searchParams = new URLSearchParams(window.location.search);
        let page = searchParams.get('page');

        $.post('/map/business-list', {
            page: page || 0,
            resultIds: JSON.stringify(resultIds),
            renderIds: JSON.stringify(renderIds),
            query: (new URLSearchParams(window.location.search).get('query')),
        }, function (data) {
            document.getElementById(outputId).innerHTML = data;
        });
    }

    function updateUrlState(searchParams) {
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({path: newUrl}, '', newUrl);
    }
}